import { passwordCase, passwordNumbers } from "helpers/password";
import * as v from "valibot";

export const resetPasswordRpcContract = {
  name: "reset-password",
  paramsSchema: v.object({
    token: v.pipe(v.string(), v.minLength(1, "Token is required")),
    email: v.pipe(v.string(), v.minLength(1, "Email is required")),
    password: v.pipe(
      v.string(),
      v.minLength(6, "Password must be at least 6 characters"),
      v.maxLength(64, "Password cannot exceed 64 characters"),
      v.regex(passwordNumbers, "Password must contain at least one number"),
      v.regex(passwordCase, "Password must contain both uppercase and lowercase letters"),
    ),
    confirmPassword: v.string(),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    message: v.string(),
  }),
} as const;
